const reportType = {
	name: 'Meldungsart | Meldungsarten',
}

export default reportType
